import React, {Component} from 'react';
import {Carousel, CarouselInner, CarouselItem, Col, ListGroup, ListGroupItem, Row} from "mdbreact";
import {API_URL, IMAGE_URL} from "../../config/Config";
import axios from "axios/index";
import MerchantMap from "../../components/map/MerchantMap";
import axiosRetry from 'axios-retry';
import PageLoader from "../../components/loader/PageLoader";
import renderHTML from 'react-render-html';
axiosRetry(axios, { retries: 3 });

export default class MerchantItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItem: 1,
            maxLength: 1,
            merchant:{},
            images:[],
            loading:false,
        };
    }
    async componentDidMount(){
        const { params } = await this.props.match;
        const id = await params.id;
        await this.getMerchantItem(id);
    }
    async getMerchantItem(id) {
        try {
            let response = await axios.get(`${API_URL}merchant/${id}`);
            let merchant = await response.data.data;
            let images = await merchant.gallery;
            let maxLength=1;
             if (images.length !== 0){
                 maxLength=images.length+1;
            }
            this.setState({merchant,images,maxLength});
        }catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);
            }
        }
        this.setState({loading: true});
    }
    render() {
        const { activeItem ,merchant,images} = this.state;

        return (
            <div style={{marginTop: 75}}>
                {!this.state.loading ? <PageLoader type="spinningBubbles" color="#f6581d"/> :
                    <div className="">
                        <div >
                            <MerchantMap lat={merchant.latitude} lng={merchant.longitude} name={merchant.name}/>

                            <div className="merchant-item-logo">
                                <img alt={merchant.name} src={IMAGE_URL + merchant.logo} style={{width: 162}}/>
                            </div>
                        </div>

                        <div className="container rtl mt-5 mb-5 white pt-3 pb-5" style={{minHeight: 500}}>
                            <Row>
                                <Col md="6" sm="12">
                                    <h1 className="p-3 deep-orange-text">{merchant.name}</h1>
                                    <p className="text-justify mt-4 md-6  p-3">
                                        {merchant.short_desc}
                                    </p>
                                    <hr/>
                                    <p className="text-justify mt-4 md-6 p-3 ">{renderHTML(merchant.description)}</p>
                                    <hr/>
                                    <ListGroup className="list-flat">
                                        <ListGroupItem><strong>خیابان :</strong>{merchant.street}</ListGroupItem>
                                        <ListGroupItem><strong>منطقه :</strong>منطقه {merchant.reign}</ListGroupItem>
                                        <ListGroupItem><strong>آدرس :</strong>{merchant.address}</ListGroupItem>
                                        <ListGroupItem><strong>تلفن :</strong>{merchant.phone}</ListGroupItem>
                                        <ListGroupItem><strong>وب سایت :</strong> <a href={merchant.website} target="_blank" rel="noopener noreferrer">{merchant.website}</a>
                                        </ListGroupItem>
                                    </ListGroup>
                                </Col>
                                <Col md="6" sm="12" className="pt-4 pb-3">
                                    {this.state.maxLength === 1 ?
                                        <img className="d-block w-100" src={IMAGE_URL + merchant.cover} alt={merchant.title}/>
                                        :
                                        <Carousel
                                            thumbnails
                                            activeItem={activeItem}
                                            length={this.state.maxLength}
                                            showControls={true}
                                            showIndicators={true}
                                            className="mt-3">
                                            <CarouselInner>
                                                <CarouselItem itemId="1">
                                                    <img className="d-block w-100" src={IMAGE_URL + merchant.cover} alt={merchant.title}/>
                                                </CarouselItem>
                                                {images.map((image, index) =>
                                                    <CarouselItem itemId={index + 2} key={index}>
                                                       <img className="d-block w-100" src={IMAGE_URL + image.image_url} alt={image.image_title}/>
                                                    </CarouselItem>
                                                )}
                                            </CarouselInner>
                                        </Carousel>
                                    }
                                </Col>
                            </Row>
                            <Row className="mt-3">
                               <Col>
                                   <h5 className="p-4 indigo-text" >امکانات قابل ارائه</h5>
                               </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="align-text-top">
                                    <i className="la la-automobile" style={{fontSize: 30, color: "#32039e"}}/> پارکینگ
                                    اتومبیل
                                </Col>
                                <Col className="align-text-top">
                                    <i className="la  la-wifi " style={{fontSize: 30, color: "#32039e"}}/>وای فای رایگان
                                </Col>
                                <Col className="align-text-top">
                                    <i className="la    la-child   " style={{fontSize: 30, color: "#32039e"}}/> اتاق بازی
                                    کودک
                                </Col>
                                <Col className="align-text-top">
                                    <i className="la   la-beer  " style={{fontSize: 30, color: "#32039e"}}/> دسر و پیش غذا
                                </Col>
                            </Row>
                            <Row>
                                <Col className="align-text-top">
                                    <i className="la la-truck" style={{fontSize: 30, color: "#32039e"}}/> ارسال رایگان
                                </Col>
                                <Col className="align-text-top">
                                    <i className="la  la-camera " style={{fontSize: 30, color: "#32039e"}}/>عکس یادگاری
                                </Col>
                                <Col className="align-text-top">
                                    <i className="la  la-gamepad " style={{fontSize: 30, color: "#32039e"}}/>بازی و سرگرمی
                                </Col>
                                <Col className="align-text-top">
                                    <i className="la   la-female  " style={{fontSize: 30, color: "#32039e"}}/> لژ خانوادگی
                                </Col>
                            </Row>
                        </div>


                    </div>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/MerchantItem.js